import { combineReducers } from '@reduxjs/toolkit'
import ruleEdit from './rule_edit'

export default combineReducers({
  ruleEdit
})